import { Component } from '@angular/core';

/**
 * Screen shown when a guest link cannot be read at all — the recipient's mail client cut it.
 *
 * Reached before any request is made, because an unreadable link carries nothing to ask the
 * backend about (FR-027). The copy deliberately does not offer to resend the link: a link that
 * arrived cut will arrive cut again at the same address, so the recipient is asked to tell the
 * sender, who probably needs a different address (D-05).
 */
@Component({
  selector: 'literax-unreadable-link',
  templateUrl: './unreadable-link.component.html',
  styleUrls: ['./unreadable-link.component.scss'],
})
export class UnreadableLinkComponent {}
